import React, { useMemo } from 'react';
import { Alert, Box, Chip, CircularProgress, Typography } from '@mui/material';

import { useSearch } from '../../context/SearchContext';
import ProductSelectionsTable from '../ProductSelectionsTable';
import ResultsTable from '../ResultsTable';

const GlobalSearchResults = ({ onNavigateToDealer, onOpenDetail, onToggleMaximize, isMaximized, userEmail }) => {
  const { searchResults, isSearching, searchError, clearSearch } = useSearch();
  const isSelectionSearch = useMemo(() => {
    return (searchResults || []).some((row) => {
      if (!row) return false;
      return Boolean(
        row.referenceId ||
          row.serviceItemName ||
          row.vendorName ||
          row.vendorCode ||
          row.productBrandCode ||
          row.productCd ||
          row.billingStartDate ||
          row.billingEndDate ||
          row.categoryCode ||
          row.categoryName ||
          row.productSelectionStatus
      );
    });
  }, [searchResults]);

  if (isSearching) return <CircularProgress />;
  if (searchError) return <Alert severity="error">{searchError.message}</Alert>;

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h6">Global Search Results:</Typography>
        <Chip label="Clear Search" onDelete={clearSearch} onClick={clearSearch} />
      </Box>
      {isSelectionSearch ? (
        <ProductSelectionsTable
          rows={searchResults}
          onNavigateToDealer={onNavigateToDealer}
          onOpenDetail={onOpenDetail}
          onToggleMaximize={onToggleMaximize}
          isMaximized={isMaximized}
          userEmail={userEmail || null}
        />
      ) : (
        <ResultsTable
          data={searchResults}
          onNavigateToDealer={onNavigateToDealer}
          onOpenDetail={onOpenDetail}
          onToggleMaximize={onToggleMaximize}
          isMaximized={isMaximized}
        />
      )}
    </Box>
  );
};

export default GlobalSearchResults;

